import { createSelector } from 'reselect';
import { getState as getAppState } from '../../../store/store';

const getAll = () => {
  const state = getAppState();
  return state.forms;
};

const getAllSelector = state => state.forms;

const getInPlaceForms = createSelector(getAllSelector, forms =>
  forms.filter(form => form.config && form.config.type === 'in_place')
);

const getModalForms = createSelector(getAllSelector, forms =>
  forms.filter(form => form.config && form.config.type === 'modal')
);

const getByToken = token => {
  const state = getAll();

  const formKey = Object.keys(state).find(
    key => state[key].instanceToken === token
  );

  return state[formKey];
};

const FormsSelectors = {
  getInPlaceForms,
  getModalForms,

  getByToken
};

export default FormsSelectors;



// WEBPACK FOOTER //
// ./src/store/forms/utils/formsSelectors.js